<!--
   Created by qing on 2020/10/19
   Des:
-->
<template>

  <div class="create-form-apply-container">
    <el-button
      v-if="needButton"
      type="text"
      :icon="icon"
      @click="onClickCreate">
      {{label}}
    </el-button>
    <van-popup
      class="create-form-popup"
      v-model="visible"
      :style="{ height: '90%', width: '100%' }"
      get-container="body"
      closeable
      safe-area-inset-bottom
      @close="beforeClose"
      position="bottom">
      <div class="fill-container" v-if="formSet.isInit">
        <h3>
          {{formSet.formName}}
        </h3>
        <div class="create-fill-content">
          <Fill :formSet="formSet" :hasHeader="true">
          </Fill>
        </div>
        <div class="footer">
          <van-button
            type="primary"
            @click="submitData">
            确定
          </van-button>
        </div>

        <FormOrderPopup
          ref="formOrderPopup"
          @submitOrder="submitOrder"
        ></FormOrderPopup>
      </div>

      <div
        style="background-color: #ffffff; height: 100%;"
        v-else>
        <van-skeleton
          style="padding-top: 20px;"
          title
          :row="16">
        </van-skeleton>
      </div>
    </van-popup>

  </div>
</template>

<script>
  import RyFormSet from "../RyForm";
  import FormOrderPopup from "./FormOrderPopup";
  import {
    FORM_ITEM__RELATE_RECORD,
    FORM_STATUS__FILL,
    FORM_SUBMIT_ERROR,
    FORM_TYPE__FILL,
    FORM_WRITE_FIELD_REPEAT
  } from "../RyForm/types";
  import {SUCCESS} from "../store/types";
  import {base64Decode, handleMessage} from "../../assets/js/Untis";
  import {PERMISSION__HIDDEN} from "../RyForm/types";
  import Fill from "../RyForm/redact/Fill";

  export default {
    props: {
      label: {
        type: String,
        default: '新建表单'
      },
      icon: {
        type: String,
        default: 'el-icon-plus'
      },
      title: {
        type: String,
        default: ''
      },
      appId: {
        type: String,
        default: ''
      },
      formId: {
        type: String,
        default: ''
      },
      needButton: {
        type: Boolean,
        default: true
      },
      reqDefaultSubmitData: {
        type: Boolean,
        default: true
      },
      formSetValue: null, // 其他地方带过来的填写表单数据
      initialValue: Object
    },
    data() {
      return {
        PERMISSION__HIDDEN,
        visible: false,
        formSet: new RyFormSet(),
        currentFlowDetail: null,
        orderErrorMsgList: [],
      }
    },
    components: {
      FormOrderPopup,
      Fill
    },
    created() {

      this.formSet.companyId = this.$store.getters.currentCompanyId
      this.formSet.userId = this.$store.getters.userId
      this.formSet.appId = this.appId
      this.formSet.formId = this.formId
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll, true)
    },
    methods: {
      onClickCreate() {
        this.visible = true
        this.fetchFlowDetail()
        this.$store.dispatch('actionMergeStructure', {
          appId: this.appId,
          formId: this.formId,
          formType: FORM_TYPE__FILL,
          viewType: 0,
        })
          .then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              return resultObject
            } else {
              throw new Error(`${status}: ${info}`)
            }
          })
          .then(({structureInfo, permissionInfo, detailInfo, pluginList, bothRelateList, displayList}) => {
            this.formSet.status = FORM_STATUS__FILL

            this.formSet.setStructure(structureInfo)
            this.formSet.setPermission(permissionInfo.permissionList)
            this.formSet.setConf(detailInfo)
            this.formSet.setPlugin(pluginList)
            this.formSet.setBothRelate(bothRelateList)
            this.formSet.setDisplayRule(displayList)

            console.log('formSet', this.formSet)

            if (this.formSetValue) {
              this.formSet.setValues(this.formSetValue)
            }
            if (this.reqDefaultSubmitData) {
              return this.$store.dispatch('actionFormDefaultSubmitData', {
                appId: this.formSet.appId,
                formId: this.formSet.formId,
                data: this.formSet.getValues()
              }).then(res => {
                this.formSet.setValues(res)
              })
            }
          })
          .then(() => {
            return Promise.all([
              this.$Socket.init(),
              this.$store.dispatch('actionTopicGet', {
                appId: this.formSet.appId,
                formId: this.formSet.formId,
              }),
            ])
          })
          .then(([init, res]) => {
            this.formSet.tmpTopic = res.tmpTopic
            this.$Socket.subscribe(res.tmpTopic, ({messageType, context, content}) => {
              console.log('$Socket--', messageType, content)
              if (messageType === this.$RySocket.MESSAGE_TYPE_PLUGIN_RESULT) {
                const {resultType, showMsg} = content
                if (showMsg && resultType === 'SUCCESS') {
                  this.$toast.success(showMsg)
                } else if (showMsg && resultType === 'FAIL') {
                  this.$toast.fail(showMsg)
                }
                const changeFlowEvent = new CustomEvent('PLUGIN_RESULT_RECEIVED', {detail: {context, content}})
                document.dispatchEvent(changeFlowEvent)
                return
              }

              handleMessage(this.formSet, {messageType, context, content})
            })
          })
          .then(() => {

            this.$emit('formSetFinalComplete', this.formSet)
            this.formSet.isInit = true
          })
          .catch(err => {
            console.log(err)
          })
      },

      close() {
        this.visible = false
      },
      beforeClose() {
        this.formSet = new RyFormSet()
        window.removeEventListener('scroll', this.handleScroll)
      },
      submitOrder({command, errList}) {
        this.orderErrorMsgList = errList
        this.buttonClick()
      },

      submitData() {

        if (this.currentFlowDetail && this.currentFlowDetail.openPay) {
          if (this.$refs.formOrderPopup) {
            this.$refs.formOrderPopup.open({
              appId: this.formSet.appId,
              formId: this.formSet.formId,
              data: this.formSet.getValues(),
              stepId: '',
              command: 'submit'
            })
          }
        } else {
          this.buttonClick()
        }
      },
      buttonClick() {
        const toast = this.$toast.loading({message: '提交中'})
        const changeList = this.formSet.getModified().map(field => {
          return {
            fieldId: field.dataId
          }
        })

        const relateHandleMap = {}
        Object.keys(this.formSet.fields).forEach(key => {
          const field = this.formSet.fields[key]
          if (field.type === FORM_ITEM__RELATE_RECORD) {
            relateHandleMap[key] = {
              addInstanceList: field.addInstanceList, //新增的实例
              deleteInstanceList: field.deleteInstanceList //删除的实例
            }
          }
        })
        // 清空字段错误信息
        this.formSet.clearError()
        this.$store.dispatch('formApply', {
          appId: this.appId,
          formId: this.formId,
          data: this.formSet.getValues(),
          changeList: changeList,
          relateHandleMap,
          showFieldIdList: this.formSet.fetchShowFieldIdList()
        })
          .then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              this.visible = false
              this.createOrder({originName: 'submit', instanceId: resultObject.instanceId})
              this.$emit('submitCallback', resultObject)
            } else if (status === FORM_SUBMIT_ERROR && info) {
              // 表单字段校验未通过
              const errInfo = JSON.parse(base64Decode(info))
              console.log('errInfo', errInfo)
              if (errInfo) {
                this.formSet.setError(errInfo)
                this.$dialog.alert({
                  title: '提交验证失败',
                  message: errInfo.errorMessage,
                }).then(() => {
                  // on close
                });
              }
              throw new Error(`${status} ${info}`)
            } else if (status === FORM_WRITE_FIELD_REPEAT) {
              this.$toast.fail({
                message: info,
                duration: '2000'
              })
              throw new Error(`${status} ${info}`)
            } else {
              this.$toast.fail({
                message: info,
                duration: '2000'
              })
              throw new Error(`${status} ${info}`)
            }
          })
          .catch(console.error)
          .finally(() => {
            toast.clear()
          })
      },

      fetchFlowDetail() {
        this.$store.dispatch('actionCompanyPaymentApplyFlowDetail', {
          appId: this.appId,
          formId: this.formId,
          stepId: ''
        }).then(res => {
          this.currentFlowDetail = res
        }).catch(console.error)
      },

      // 下单、跳转到收银台
      createOrder({originName, instanceId}) {
        if (this.currentFlowDetail &&
          this.currentFlowDetail.openPay &&
          (!this.orderErrorMsgList || !this.orderErrorMsgList.length) &&
          (originName === 'submit' || originName === 'agree')) {

          this.$store.dispatch('actionCompanyPaymentApplyOrderCreate', {
            appId: this.formSet.appId,
            formId: this.formSet.formId,
            instanceId,
            stepId: '',
          }).then(res => {
            this.$router.push({
              name: 'payment_gateway',
              query: {
                o: res.orderId
              }
            })
          }).catch(console.error)
        }
        this.orderErrorMsgList = null
      },
      handleScroll() {

        const tab = document.getElementsByClassName('el-tabs__header')[0]
        const content = document.getElementsByClassName('create-fill-content')[0]

        if (!document.querySelector('#formTabs')) {
          return
        }
        const  offsetTop = document.querySelector('#formTabs').offsetTop


        if (content.scrollTop + 44 > offsetTop) {
          tab.style.position = 'fixed'
          tab.style.top = 'calc(10% + 44px)'
          tab.style.left = 0
          tab.style.right = 0
          tab.style.zIndex = 1000
          tab.style.background = '#ffffff'
        } else {
          tab.style.position = 'relative'
          tab.style.top = 0
          tab.style.zIndex = 0
          tab.style.background = '#ffffff'
        }
        console.log('handleScroll', content.scrollTop, offsetTop)
      },
    }
  }
</script>

<style lang="less">

  .create-form-popup {

    .fill-container {
      height: 100%;

      > h3 {
        font-size: 20px;
        line-height: 44px;
        padding-left: 16px;
        border-bottom: 1px solid #e6e6e6;
        margin: 0;
      }

      .create-fill-content {
        height: calc(100% - 54px - 44px);
        overflow: auto;
        -webkit-overflow-scrolling: touch;

        .form__section {
          height: 100%;
          /*overflow: auto;*/
        }
      }

      .footer {
        height: 54px;
        display: flex;
        justify-content: center;
        align-items: center;

        .van-button {
          width: 80%;
          border-radius: 30px;
        }
      }
    }

    .van-popup__close-icon--top-right {
      top: 10px;
    }
  }
</style>
